module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-8.9a2f4f87.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-8.mp3
// module id = 130
// module chunks = 0